import styled from 'styled-components';

export const SeachResultPageWrapper = styled.section(
  props => `
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: ${props.theme.colors.grey.lineGrey};
    position: relative;
  `,
);

export const HomeBodyWrapperContentDiv = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 120rem;
    margin: 0 auto;
  `,
);

export const BackBlueRoundDark = styled.div(
  props => `
      width: 111rem;
      height: 95rem;
      background-color: ${props.theme.colors.goBrand.blue};
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      top: -53rem;
      left: -69rem;
      transform: translate(50%);
      z-index: ${props.theme.misc.zIndex.xxsmall};
  `,
);

export const BackBlueRoundLight = styled.div(
  props => `
      width: 117rem;
      height: 100rem;
      background-color: ${props.theme.colors.blue.bgBlueLightHome};
      border-radius: ${props.theme.misc.borderRadius.round};
      position: absolute;
      top: -58rem;
      left: -76rem;
      transform: translate(50%);
  `,
);

export const HomeContentOuterWrapper = styled.div(
  props => `
    display: flex;
    width: 100%;
    flex-direction: column;
    width: 100%;
  `,
);

export const PageOverlay = styled.div(
  props => `
    display: flex;
    width:100%;
    background-color: ${props.theme.colors.black.base};
    opacity:0.4;
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${props.theme.misc.zIndex.base};
  `,
);

export const SearchBlockOuterWrapper = styled.section(
  props => `
    width: 100%;
    display: flex;
    margin: ${props.theme.spacing.xxlarge} 0;
  `,
);

/** styling for offer block  **/

export const OfferBlockConatiner = styled.div(
  props => `
    width:31rem;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    box-shadow: 0 ${props.theme.spacing.xsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.light
  };
  `,
);

export const OfferBlockInnerContainer = styled.div(
  props => `

  display:flex;
  border-bottom: 1px solid ${props.theme.colors.blue.blueBorder};
  &:last-child {
    border-bottom: none;
  };
  padding:${props.theme.spacing.large};
  `,
);

export const OfferBlockWrap = styled.div(
  props => `

  margin-right:${props.theme.spacing.base};

  `,
);

export const OfferBlocklabel = styled.span(
  props => `

  font-size: ${props.theme.font.custom(14)};
  font-weight:bold;
  color: ${props.theme.colors.black.base};
  `,
);

export const PreAppliedWrap = styled.span(
  props => `

  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.green.base};
  background-color: ${props.theme.colors.green.lightGreen};
  padding: 0 ${props.theme.spacing.small};
  border-radius:${props.theme.misc.borderRadius.xxlarge};
  `,
);

export const PromoLabel = styled.span(
  props => `

  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.black.base};
  `,
);

export const OfferDescription = styled.p(
  props => `

  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.grey.grey75};
  margin-top:${props.theme.spacing.small};
  `,
);

export const OfferSubDescription = styled.p(
  props => `

  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.grey.grey50};
  `,
);

export const UnlockOffer = styled.a(
  props => `

  font-size: ${props.theme.font.small};
  color: ${props.theme.colors.goBrand.blue};
  cursor:pointer;
  margin-top:${props.theme.spacing.small};
  `,
);

/*** GPT BENEFITS CARD */

export const GPTBenefitsCardWrapper = styled.div(
  props => `

  width:23.5rem;

  background-image: linear-gradient(to right, #aa9a55 , #d2bd60);
  // background-image: linear-gradient(to right, #121212 , #4b5a6a);
  // background-image: linear-gradient(to right, #345471 , #5980a3);
  padding:${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.base}
  position:relative;
  &::after {
    left: 100%;
    top: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-left-color: #d2bd60;
    border-width: 8px;
    margin-top: -15px;
  }

  `,
);

export const ExclusivePriceWrap = styled.div(
  props => `

  width:10rem;
  background-color: #8d7f3e;
  padding:0 ${props.theme.spacing.small};
  border-radius: ${props.theme.misc.borderRadius.custom(3)}
  margin-bottom: ${props.theme.spacing.base};
  `,
);

export const PriceContainer = styled.p(
  props => `

  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.white.base};
  font-weight:bold;

  `,
);

export const ExclusiveDealContainer = styled.p(
  props => `

  font-size: ${props.theme.font.base};
  color: ${props.theme.colors.white.base};
  `,
);

export const GPTOfferIconWrap = styled.div(
  props => `

  display:flex;
  `,
);

export const GPTBenefitsListWrap = styled.ul(
  props => `
    list-style-type: none;

    li{
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      margin-bottom: ${props.theme.spacing.small};
      padding-left: ${props.theme.spacing.small};

      }
  `,
);

const GPTBenefitsStar = styled.img(
  props => `
  width: 39rem;
  height: 21rem;
  display: flex;
  position: relative;
  border-radius: ${props.theme.misc.borderRadius.xxlarge};
  object-fit: cover;
    `,
);

/*** go stay hover */

export const WrapperDivContainer = styled.section(
  props => `

  border-radius: ${props.theme.misc.borderRadius.base};
  background-color: ${props.theme.colors.goBrand.blue};
  width: 25rem;
  padding:${props.theme.spacing.xlarge};
  z-index:999;
  position:relative;
  overflow:hidden;
`,
);

export const SliderGoStaysCircle = styled.div(
  props => `
  width: 60rem;
  height: 42rem;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.blue.deepBlue};
  display: flex;
  position: absolute;
  top: -35rem;
  right: -17rem;
  z-index:-1;
  `,
);

export const GoStayHoverHeader = styled.div(
  props => `

  padding: ${props.theme.spacing.small} 0;
  display:flex;

`,
);

export const GoStayImageWrap = styled.img(
  props => `

  width: 3rem;
  height: 3rem;


`,
);

export const GoStayTitleWrap = styled.p(
  props => `

  font-size: ${props.theme.font.large};
  color: ${props.theme.colors.white.base};
  font-family: ${props.theme.font.fontFamily};
  font-weight:bold;
  margin-bottom:${props.theme.spacing.base};
  padding-left: ${props.theme.spacing.base};
`,
);

export const GoStayHoverContent = styled.ul(
  props => `

  list-style-type:none;
  margin:${props.theme.spacing.large} 0;
`,
);

export const ShieldContainerWrap = styled.div(
  props => `

  display:flex;
  align-items: center;

`,
);

export const GoStayHoverList = styled.li(
  props => `

  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.white.base};
  margin:${props.theme.spacing.small} 0;
`,
);

export const ShowPropertiesBtn = styled.button(
  props => `

  font-size: ${props.theme.font.custom(14)};
  font-weight:bold;
  color: ${props.theme.colors.white.base};
  background-color: ${props.theme.colors.goBrand.blue};
  border:1px solid ${props.theme.colors.white.base}
  border-radius: ${props.theme.misc.borderRadius.custom(16)}
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large}
`,
);

/*** Banner loader  ***/

export const BannerLoaderContainer = styled.div(
  props => `

  display: flex;
  width:100%;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  padding: ${props.theme.spacing.base};
  flex-direction: column;
  width:60rem;

`,
);

export const BannerImageLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius:${props.theme.misc.borderRadius.custom(10)};
  height:19rem;
  width:59rem;
  margin-bottom :${props.theme.spacing.large};

`,
);

export const BannerLoaderOuterWrap = styled.div(
  props => `

  display:flex;
  justify-content:space-between;

`,
);

export const BannerLoaderInnerWrap = styled.div(
  props => `

  display:flex;
  margin-right: ${props.theme.spacing.xlarge};
  flex-direction: column;

`,
);

export const OfferImageLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius:${props.theme.misc.borderRadius.small};
  width:28.5rem;
  height:10.8rem;
  margin-bottom :${props.theme.spacing.base};

`,
);

export const OfferDetailsLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius:${props.theme.misc.borderRadius.small};
  width:24.5rem;
  height:3.8rem;
  margin-bottom :${props.theme.spacing.base};
  margin-left:auto;
  margin-right:auto;

`,
);

export const OfferValidLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius:${props.theme.misc.borderRadius.small};
  width:24.5rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.base};
  margin-left:auto;
  margin-right:auto;

`,
);

export const SliderPriceLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius:${props.theme.misc.borderRadius.small};
  width:10rem;
  height:7rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const SliderOfferLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.blue.lightBlue};
  border-radius:${props.theme.misc.borderRadius.small};
  width:7rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.small};

`,
);
